<template>
  <v-container style="background-color: white; border-radius: 5px; max-width: 1000px" >
    <v-layout
            wrap
    >
      <v-flex xs12>
        <GalleryComponent :images="largeGalleryImages" :show-more="showMore" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import GalleryComponent from './GalleryComponent'
  import { sync } from 'vuex-pathify';
  const axios = require('axios');

  export default {
    name: 'Gallery',
    components: { GalleryComponent },
    data() {
      return {
        showMore: false,
      }
    },
    computed: {
      ...sync(['largeGalleryImages', 'serviceUrl', 'serviceEndpoints.GET_GALLERY_MAIN'])
    },
    mounted: function () {
      let me = this;
      axios.get(this.serviceUrl + this.GET_GALLERY_MAIN)
              .then(function (response) {
                me.largeGalleryImages = response.data.payload;
              })
              .catch(function (error) {
                console.log(error);
              })
    },
  }
</script>

<style>
</style>
